import styled from 'styled-components'
import { breakpoints } from './../../constants/breakpoits.constants'
import FontAwesome from 'react-fontawesome'

export const StyledContainerReverseRounded = styled.div`
	padding: 5px 7px;
	position: absolute;
	z-index: 2;
	top: 18%;
	right: 40px;
	transform: translate(0, -50%);
	width: 45px;
	height: 45px;
	border: 1px solid #666;
	border-radius: 100%;
	background: #fff;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 37px;
		padding: 5px 4px;
		background: none;
		border-radius: 0;
		border: 0;
		cursor: pointer;
		position: unset;
		transform: translate(0, 0);
	}
`

export const StyledIconFontAwesome = styled(FontAwesome)`
	position: absolute;
	right: 40px;
	top: 20px;
	z-index: 1;
	transform: rotate(270deg);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #517abc;
	height: 40px;
	width: 20px;
	font-size: 22px;
	cursor: pointer;
	background-color: #fff;
	border: 1px solid #000;
	padding: 25px 25px;
	border-radius: 50%;

	@media (min-width: ${breakpoints.MOBILE}px) {
		transform: rotate(0deg);
		color: ${({ isRootUrl }) => (!isRootUrl ? '#fff' : '#517abc')};
		background-color: transparent;
		border: none;
		border-radius: 50%;
		position: relative;
		right: 0px;
		top: 0px;
		padding: 25px 0px;
	}
`

export const SearchContainer = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	align-items: center;
	flex: 1;
	gap: 10px;

	/* > div:not(:first-child):not(:last-child) {
		margin: 10px 0px 10px 0px;
	} */

	/* > div:last-child {
		margin-top: 10px;
	} */

	@media (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;

		/* > div:not(:first-child):not(:last-child) {
			margin: 0px 10px;
		} */

		/* > div:last-child {
			margin-top: 0px;
			margin-left: 10px;
		} */

		/* > span {
			margin-left: 10px;
		} */
	}
`

export const InputSearchCity = styled.div`
	flex: 2;
	margin-bottom: 10px;
	width: 100%;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-bottom: 0px;
	}
`

export const InputSearchDate = styled.div`
	flex: 1.5;
	margin-bottom: 10px;
	width: 100%;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-bottom: 0px;
	}
`

export const BtnSearchTrip = styled.div`
	flex: 1.5;
	margin-bottom: 10px;
	width: 100%;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-bottom: 0px;

		> button {
			width: 100%;
		}
	}
`
